import { Fab, styled } from '@mui/material'

/**
 * Floating Action Button component with custom styles
 * This component is styled using MUI's styled API.
 */
export const FloatingActionButton = styled(Fab)(({ theme }) => ({
  background: theme.palette.primarySoft.main,
  color: theme.palette.primarySoft.contrastText,
  gap: theme.spacing(1),
  textTransform: 'none',

  '&:hover': {
    background: theme.palette.primarySoft.main,
    color: theme.palette.primarySoft.contrastText,
    transform: 'scale(1.01)'
  }
}))
